<template>
  <div class="custom-field-form">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group mb-2">
          <label class="form-label">{{ $t('customField.fieldType') }}</label>
          <select class="form-control" :value="value.fieldType" @change="update('fieldType', $event.target.value)">
            <option value="input">{{ $t('customField.types.input') }}</option>
            <option value="textarea">{{ $t('customField.types.textarea') }}</option>
            <option value="select">{{ $t('customField.types.select') }}</option>
            <option value="multiselect">{{ $t('customField.types.multiselect') }}</option>
            <option value="boolean">{{ $t('customField.types.boolean') }}</option>
            <option value="confirmation">{{ $t('customField.types.confirmation') }}</option>
            <option value="number">{{ $t('customField.types.number') }}</option>
            <option value="date">{{ $t('customField.types.date') }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group mb-2">
          <label class="form-label">{{ $t('customField.label') }}</label>
          <input type="text" class="form-control" :value="value.label" @input="update('label', $event.target.value)">
        </div>
      </div>
      <div class="col-md-4" v-if="!isBooleanType">
        <div class="form-group mb-2">
          <label class="form-label">{{ $t('customField.placeholder') }}</label>
          <input type="text" class="form-control" :value="value.placeholder" @input="update('placeholder', $event.target.value)">
        </div>
      </div>
    </div>

    <div v-if="isSelectType" class="form-group mb-2">
      <label class="form-label w-100">{{ $t('customField.options') }}</label>
      <div v-for="(option, i) in value.options" :key="i" class="d-flex mb-1" style="gap: 8px;">
        <input type="text" class="form-control form-control-sm" :value="option" @input="updateOption(i, $event.target.value)">
        <button type="button" class="btn btn-sm btn-light text-danger" @click="removeOption(i)">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <button type="button" class="btn btn-sm btn-outline-secondary mt-1" @click="addOption">
        <i class="fa fa-plus mr-1"></i>{{ $t('customField.addOption') }}
      </button>
    </div>

    <div class="d-flex align-items-center mt-2" style="gap: 12px;">
      <div class="custom-control custom-switch">
        <input
          type="checkbox"
          class="custom-control-input"
          :id="`required-${_uid}`"
          :checked="value.required"
          @change="update('required', $event.target.checked)"
        >
        <label class="custom-control-label" :for="`required-${_uid}`">{{ $t('required') }}</label>
      </div>
      <div class="ml-auto d-flex" style="gap: 8px;">
        <button type="button" class="btn btn-sm btn-light" @click="$emit('cancel')">{{ $t('action.cancel') }}</button>
        <button type="button" class="btn btn-sm btn-success" @click="$emit('save')">{{ $t('save') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    applicationType: {
      type: String,
      required: true
    }
  },
  computed: {
    isSelectType () {
      return this.value.fieldType === 'select' || this.value.fieldType === 'multiselect'
    },
    isBooleanType () {
      return this.value.fieldType === 'boolean' || this.value.fieldType === 'confirmation'
    }
  },
  methods: {
    update (key, val) {
      const updated = { ...this.value, [key]: val }
      if (!this.isSelectType) updated.options = []
      this.$emit('input', updated)
    },
    addOption () {
      this.$emit('input', { ...this.value, options: [...(this.value.options || []), ''] })
    },
    updateOption (index, val) {
      const options = [...this.value.options]
      options[index] = val
      this.$emit('input', { ...this.value, options })
    },
    removeOption (index) {
      const options = this.value.options.filter((_, i) => i !== index)
      this.$emit('input', { ...this.value, options })
    }
  }
}
</script>

<style scoped>
.custom-field-form {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 16px;
  border: 1px solid #e4e7ed;
}
</style>
